<template>
    <div>
        <div class="mb-24">
            <select-dropdown
                v-model="filterFields.requestReasonIds"
                reference="id"
                label="title"
                :auto-translate="false"
                translatable
                multiple
                searchable
                :loading="fetching"
                :options="requestReasons"
                :placeholder="$t('form.dropdown.placeholder')"
                remove-icon
                can-select-all
                :input-label="$t('settings.vacancy.reasons.request')"
            />
        </div>
        <div class="mb-24">
            <select-dropdown
                v-model="filterFields.rejectReasonIds"
                reference="id"
                label="title"
                :auto-translate="false"
                translatable
                multiple
                searchable
                :loading="fetching"
                :options="rejectReasons"
                :placeholder="$t('form.dropdown.placeholder')"
                remove-icon
                can-select-all
                :input-label="$t('settings.vacancy.reasons.reject')"
            />
        </div>
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown";
import * as jobReasonService from "../../services/JobReasonService";
import JobReason from "../../models/JobReason";
import {normalizeJson} from "../../../shared/helpers";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';

export default {
    name: 'FilterJobReasons',
    components: {
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object},
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'selectedLocale']),
        requestReasons() {
            return this.jobReasons();
        },
        rejectReasons() {
            return this.jobReasons(1);
        },
        languages() {
            return this.currentCompany.jobsite.active_languages;
        },
        locale() {
            return this.selectedLocale;
        }
    },
    data() {
        return {
            fetching: true
        }
    },
    methods: {
        jobReasons(rejected = 0) {
            let reasons = useRepo(JobReason)
                .where('is_rejected', rejected)
                .get();
            reasons.forEach((reason) => {
                this.formatTranslations(reason)
            })
            reasons.sort((a, b) => a.title[this.locale]?.localeCompare(b.title[this.locale]));
            return reasons;
        },
        formatTranslations(reason) {
            this.languages.forEach((lang) => {
                if (!reason.title[lang]) {
                    reason.title[lang] = null
                }
            })
        },
        fetch() {
            jobReasonService.index().then(({data}) => {
                return useRepo(JobReason).save(normalizeJson(data));
            }).then(() => {
                this.fetching = false;
            })
        },
    },
    mounted() {
        if (!useRepo(JobReason).all().length) this.fetch()
        else this.fetching = false
    },
}
</script>
